export const DEMO_APPOINTMENT_SOURCE = 'demo-screenshot';

export const DEMO_SEED_DATA_SOURCE = {
  COMPANY: 'company',
  DEFAULT: 'default',
};

export const demoAppointmentIdsStorageKey = (companyId) =>
  `neatschedule:demo-appointment-ids:${companyId}`;

export const demoSeedDataSourceStorageKey = () =>
  'neatschedule:demo-seed-data-source';

/** Same gate as payment gateway environments — `users/{uid}.isSpecialAdmin`. */
export const isDemoAppointmentsToolsEnabled = (isSpecialAdmin) => Boolean(isSpecialAdmin);
